import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faComments, faBuilding, faPlane, faPercentage, faEnvelope, faTimes, faCalendar,
} from '@fortawesome/free-solid-svg-icons';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { buildCurrentMemberSelector } from 'store/selectors/members.selector';
import Button from 'components/UI/Button';
import Dialog from 'components/UI/Dialog';
import _ from 'lodash';
import { brandValues } from 'utils/brandValues';
import Row from 'components/UI/Layout/Row';
import Col from 'components/UI/Layout/Col';

function ContactUs({
    authMember, className, reference, conciergeEmail, isB2cPage,
})
{
    const defaultMails = _.get(brandValues, `${isB2cPage ? 'B2C' : 'B2B'}.EMAILS`);
    const [openState, setOpenState] = useState(false);
    const [isCalendly, setIsCalendly] = useState(false);
    const parsedReference = reference ? `%20-%20${reference}` : '';
    const authUserEmail = authMember.user?.userEmails?.find((userEmail) => userEmail.default === 1);

    return (
        <div className={`max-sm:tw-fixed max-sm:tw-z-50 max-sm:tw-top-0 max-sm:tw-right-0 md:tw-h-full ${openState ? 'max-sm:tw-w-36 max-sm:tw-h-full' : ''}`}>

            <FontAwesomeIcon
                className={`tw-cursor-pointer tw-hidden tw-p-2 ${openState ? 'max-sm:tw-hidden' : 'max-sm:tw-block'} tw-cursor-pointer tw-w-6 tw-h-6 tw-bg-ivory-background tw-rounded-md tw-m-2 tw-text-black`}
                icon={faEnvelope}
                role="button"
                onClick={() => setOpenState((prevState) => (!prevState))}
            />

            <div className={`tw-p-6 tw-bg-contact-us-background tw-rounded tw-max-w-sm ${className} ${openState ? 'max-sm:tw-h-full' : 'max-sm:tw-hidden'}`}>

                <Button icon={faTimes} className="tw-text-center max-sm:tw-inline-block tw-hidden" margin="tw-mt-0 tw-mb-2 tw-w-full" customBg="tw-bg-primary-hover" iconMargin="tw-mr-0" onClick={() => setOpenState(false)}> Close</Button>

                <h2 className="tw-font-title tw-text-center tw-text-white tw-pb-4">Contact Us</h2>
                <div className="tw-flex tw-items-start tw-justify-center tw-flex-wrap tw-gap-2 tw-text-center tw-text-white">
                    <a target="_blank" className="tw-group tw-flex tw-flex-col  tw-w-[80px] tw-h-[85px] " href={`mailto:${conciergeEmail ?? authUserEmail?.email ?? defaultMails.INFO}?subject=Inquiry${parsedReference}.`}>
                        <div className="tw-p-2 tw-rounded tw-h-full tw-flex tw-justify-center tw-items-center tw-w-[60px]  tw-max-h-[60px] tw-mx-auto dark:tw-bg-contact-us-button-background-dark dark:tw-text-contact-us-button-text tw-bg-contact-us-button-background tw-text-contact-us-button-text group-hover:tw-bg-white tw-mb-1">
                            <FontAwesomeIcon className="tw-text-contact-us-button-text dark:tw-text-contact-us-button-text-dark tw-text-lg group-hover:tw-text-black" icon={faComments} />
                        </div>
                        <span className="tw-text-xs tw-text-neutral-100 group-hover:tw-text-white"> Reservations </span>
                    </a>

                    <a target="_blank" className="tw-group tw-flex tw-flex-col  tw-w-[80px] tw-h-[85px] " href={`mailto:${defaultMails.AIR}?subject=Flights%20Inquiry${parsedReference}.`}>
                        <div className="tw-p-2 tw-rounded tw-h-full tw-flex tw-justify-center tw-items-center tw-w-[60px]  tw-max-h-[60px] tw-mx-auto dark:tw-bg-contact-us-button-background-dark dark:tw-text-contact-us-button-text tw-bg-contact-us-button-background tw-text-contact-us-button-text group-hover:tw-bg-white tw-mb-1">
                            <FontAwesomeIcon className="tw-text-contact-us-button-text dark:tw-text-contact-us-button-text-dark tw-text-lg group-hover:tw-text-black" icon={faPlane} />
                        </div>
                        <span className="tw-text-xs tw-text-neutral-100 group-hover:tw-text-white"> Air </span>
                    </a>
                    {!isB2cPage && (
                        <a target="_blank" className="tw-group tw-flex tw-flex-col  tw-w-[80px] tw-h-[85px] " href={`mailto:${defaultMails.COMMISSIONS}?subject=Commissions%20Inquiry${parsedReference}.`}>
                            <div className="tw-p-2 tw-rounded tw-h-full tw-flex tw-justify-center tw-items-center tw-w-[60px]  tw-max-h-[60px] tw-mx-auto dark:tw-bg-contact-us-button-background-dark dark:tw-text-contact-us-button-text tw-bg-contact-us-button-background tw-text-contact-us-button-text group-hover:tw-bg-white tw-mb-1">
                                <FontAwesomeIcon className="tw-text-contact-us-button-text dark:tw-text-contact-us-button-text-dark tw-text-lg group-hover:tw-text-black" icon={faPercentage} />
                            </div>
                            <span className="tw-text-xs tw-text-neutral-100 group-hover:tw-text-white"> Commissions </span>
                        </a>
                    )}

                    <a target="_blank" className="tw-group tw-flex tw-flex-col tw-w-[80px] tw-h-[96px] tw-min-h-[96px]" href={`mailto:${defaultMails.INFO}?subject=Inquiry${parsedReference}.`}>
                        <div className="tw-p-2 tw-rounded tw-h-full tw-flex tw-justify-center tw-items-center tw-w-[60px]  tw-max-h-[60px] tw-mx-auto dark:tw-bg-contact-us-button-background-dark dark:tw-text-contact-us-button-text tw-bg-contact-us-button-background tw-text-contact-us-button-text group-hover:tw-bg-white tw-mb-1">
                            <FontAwesomeIcon className="tw-text-contact-us-button-text dark:tw-text-contact-us-button-text-dark tw-text-lg group-hover:tw-text-black" icon={faBuilding} />
                        </div>
                        <span className="tw-text-xs tw-text-neutral-100 group-hover:tw-text-white"> New to UJV? Contact Us! </span>
                    </a>

                    {!isB2cPage && (
                        <button type="button" className="tw-group tw-flex tw-flex-col  tw-w-[80px] tw-h-[128px] " onClick={() => setIsCalendly(true)}>
                            <div className="tw-p-2 tw-rounded tw-h-full tw-flex tw-justify-center tw-items-center tw-w-[60px]  tw-max-h-[60px] tw-mx-auto dark:tw-bg-contact-us-button-background-dark dark:tw-text-contact-us-button-text tw-bg-contact-us-button-background tw-text-contact-us-button-text group-hover:tw-bg-white tw-mb-1">
                                <FontAwesomeIcon className="tw-text-contact-us-button-text dark:tw-text-contact-us-button-text-dark tw-text-lg group-hover:tw-text-black" icon={faCalendar} />
                            </div>
                            <span className="tw-mx-auto tw-text-xs tw-text-neutral-100 group-hover:tw-text-white">Schedule a time with a Business Developer!</span>
                        </button>
                    )}
                </div>
            </div>
            <Dialog
                model={{ value: isCalendly, setter: setIsCalendly }}
                footer={(
                    <button
                        onClick={() => setIsCalendly(false)}
                        type="button"
                        className="tw-mt-3 tw-inline-flex tw-w-full tw-justify-center tw-rounded tw-border tw-border-gray-300 tw-bg-white tw-px-4 tw-py-2 tw-text-base tw-font-medium tw-text-gray-700 tw-shadow-sm hover:tw-bg-gray-50 focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-indigo-500 focus:tw-ring-offset-2 sm:tw-mt-0 sm:tw-ml-3 sm:tw-w-auto sm:tw-text-sm dark:tw-bg-ivory-background"
                    >
                        Close
                    </button>
                )}

            >
                <div>
                    <h3 className="tw-text-lg tw-font-medium tw-leading-6 tw-text-gray-900 dark:tw-text-gray-100">
                        Schedule a time with a Business Developer!
                    </h3>

                    <Row className="tw-py-2.5">
                        <Col>
                            <a className="tw-text-primary-default hover:tw-text-primary-hover" target="_blank" href="https://cal.frontapp.com/ultimate-jet-vacations/kp/b248b728">
                                Kevin Peyrache
                            </a>
                        </Col>
                        <Col>
                            <a className="tw-text-primary-default hover:tw-text-primary-hover" target="_blank" href="https://cal.frontapp.com/ultimate-jet-vacations/simon/ddd2c79d">
                                Simon Jones
                            </a>
                        </Col>
                    </Row>
                    <Row className="tw-py-2.5">
                        <Col>
                            <a className="tw-text-primary-default hover:tw-text-primary-hover" target="_blank" href="https://cal.frontapp.com/ultimate-jet-vacations/nicholas/c920f49d">
                                Nick Adolph
                            </a>
                        </Col>
                        <Col>
                            <a className="tw-text-primary-default hover:tw-text-primary-hover" target="_blank" href="https://cal.frontapp.com/ultimate-jet-vacations/jonathan/e52060a2">
                                Jonathan Marin
                            </a>
                        </Col>
                    </Row>
                    <Row className="tw-py-2.5">
                        <Col>
                            <a className="tw-text-primary-default hover:tw-text-primary-hover" target="_blank" href="https://cal.frontapp.com/ultimate-jet-vacations/kmartinez/428930e2">
                                Kevin Martinez
                            </a>
                        </Col>
                    </Row>
                </div>
            </Dialog>
        </div>
    );
}

ContactUs.defaultProps = {
    isB2cPage: false,
};

ContactUs.propTypes = {
    authMember: PropTypes.object,
    className: PropTypes.string,
    reference: PropTypes.string,
    conciergeEmail: PropTypes.string,
    isB2cPage: PropTypes.bool,
};

const mapStateToProps = () =>
{
    const authMemberSelector = buildCurrentMemberSelector();

    return (state) => ({
        authMember: authMemberSelector(state),
    });
};

export default connect(mapStateToProps)(ContactUs);
